import {LastReplacementDatePicker} from '../components/LastReplacementDatePicker';
import {LastReplacementMileageInput} from '../components/LastReplacementMileageInput';
import {NextReplacementDatePicker} from '../components/NextReplacementDatePicker';
import {NextReplacementMileageInput} from '../components/NextReplacementMileageInput';
import {ReplacementAfterMileageInput} from '../components/ReplacementAfterMileageInput';
import {ReplacementAfterMonthsInput} from '../components/ReplacementAfterMonthsInput';

export function GearboxOilReplacementGroup() {
  return (
    <>
      <LastReplacementDatePicker name="gearboxOil" />
      <LastReplacementMileageInput name="gearboxOil" />
      <NextReplacementDatePicker name="gearboxOil" />
      <NextReplacementMileageInput name="gearboxOil" />
      <ReplacementAfterMonthsInput name="gearboxOil" />
      <ReplacementAfterMileageInput name="gearboxOil" />
    </>
  );
}
